export const DEFAULT_CONSOLE_URL = "https://console.agentmaurice.app";

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

function isAbsoluteHttpUrl(value: string): boolean {
  return /^https?:\/\//i.test(value);
}

/**
 * Vite `/console-api` must target the same Console as `getConsoleUrl()`.
 * A silent fallback to localhost:8080 while the app defaults to production
 * sends the Hanko JWT to a stale local Console (401 invalid token).
 */
export function resolveConsoleProxyTarget(env: {
  VITE_CONSOLE_PROXY_TARGET?: string;
  VITE_CONSOLE_URL?: string;
}): string {
  const explicit = env.VITE_CONSOLE_PROXY_TARGET?.trim();
  if (explicit) {
    return trimTrailingSlash(explicit);
  }

  const consoleUrl = env.VITE_CONSOLE_URL?.trim();
  if (consoleUrl && isAbsoluteHttpUrl(consoleUrl)) {
    return trimTrailingSlash(consoleUrl);
  }

  return DEFAULT_CONSOLE_URL;
}
